<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">教务中心</span>
      / 上课记录
    </div>

    <div class="classRecord">
      <section>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="点名记录" name="second" v-if="$attrs.methodAuthTabView('点名记录')">
            <el-form style="margin-top: 10px" :inline="true" size="small" @submit.native.prevent>
              <el-form-item label="上课老师:" v-if="
                  $attrs.methodAuthTabView('点名记录', '查询').viewScope !== 1
                ">
                <el-select size="small" @change="search2" v-model="form.tchId" placeholder="请输入老师姓名" clearable>
                  <el-option v-for="item in options3" :key="item.id" :label="item.realname + ' ' + '(' + item.name + ')'" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="讲次名称:">
                <el-input clearable style="width: 250px" v-model="form.lesson_title" placeholder="请输入讲次" @keyup.enter.native="search2"></el-input>
              </el-form-item>
              <!-- <el-form-item label="记录课时:">
                <el-select style="width: 100px;" v-model="form.isCostLessonHour" placeholder="" @change="search2">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item>
                <el-button type="primary" @click="search2" icon="el-icon-search" v-if="$attrs.methodAuthTabView('点名记录', '查询')">查询</el-button>
              </el-form-item>
              <br />
              <el-form-item label="上课时间:">
                <el-date-picker :picker-options="pickerOptions1" @change="search2" v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="点名时间:">
                <el-date-picker :picker-options="pickerOptions1" @change="search2" v-model="form.sigin_time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
                </el-date-picker>
              </el-form-item>
              <br />
              <el-form-item label="班级名称:">
                <el-input clearable style="width: 250px" v-model="form.className" placeholder="请输入班级名称" @keyup.enter.native="search2"></el-input>
              </el-form-item>
              <el-form-item label="记录课时:">
                <el-radio @change="search2" v-model="form.isCostLessonHour" label="0">全部</el-radio>
                <el-radio @change="search2" v-model="form.isCostLessonHour" label="1">是</el-radio>
                <el-radio @change="search2" v-model="form.isCostLessonHour" label="2">否</el-radio>
              </el-form-item>
              <el-form-item style="margin-left: 15px;">
                <el-button type="primary" size="small" @click="handleExport" v-if="$attrs.methodAuthTabView('点名记录', '导出点名记录')">导出点名记录</el-button>
              </el-form-item>
            </el-form>

            <div class="table-style">
              <el-table size="small" id="table2" :data="tableData1" @selection-change="handleSelectionChange2" :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }" stripe>
                <!-- <el-table-column type="selection" width="55">
                </el-table-column> -->
                <el-table-column align="center" width="50" label="序号">
                  <template slot-scope="scope">
                    <span>{{
                      scope.$index + 1 + (page_no1 - 1) * page_size1
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="tchPlanSignData" width="150" label="点名时间">
                </el-table-column>
                <el-table-column prop="className" label="班级名称" width="200">
                </el-table-column>

                <el-table-column prop="lessonTitle" label="讲次名称">
                </el-table-column>

                <el-table-column prop="tchPlanSignData1" label="上课时间" width="250">
                  <template slot-scope="scope">
                    <span v-if="scope.row.start_class_date">
                      {{ scope.row.start_class_date }}
                      <!-- -
                      {{ scope.row.end_class_date.slice(10, 16) }} -->
                    </span>
                  </template>
                </el-table-column>

                <el-table-column prop="lecturerName" label="上课老师">
                </el-table-column>

                <el-table-column prop="costLessonHour" label="授课课时">
                </el-table-column>

                <el-table-column prop="" align="center" label="实到/应到" width="150">
                  <template slot-scope="scope">
                    <span>{{ scope.row.attendRate }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="totalCostMoney" label="课消金额">
                  <template slot-scope="scope">
                    <span>¥
                      {{
                        parseFloat(scope.row.totalCostMoney).toFixed(2)
                      }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="num(scope.row)" size="mini">详情</el-button>
                    <!-- <el-button type="text" size="mini">点评</el-button> -->
                    <!-- <el-button type="text">撤销</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-style">
              <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="page_no1" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size1" layout="total, sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
            </div>
          </el-tab-pane>

          <el-tab-pane label="学生缺课记录" name="first" v-if="$attrs.methodAuthTabView('学生缺课记录')">
            <el-form style="margin-top: 10px" :inline="true" size="small" @submit.native.prevent>
              <el-form-item label="学员姓名:">
                <!-- <el-input clearable style="width: 250px" v-model="teachplan_form.stu_realname" placeholder="请输入学员姓名"
                  @keyup.enter.native="search"></el-input> -->
                <autocomplete @getUserId="getUserId" @getUserName="getUserName"></autocomplete>
              </el-form-item>
              <el-form-item label="讲次名称:">
                <el-input clearable style="width: 250px" v-model="teachplan_form.lesson_title" placeholder="请输入讲次" @keyup.enter.native="search"></el-input>
              </el-form-item>

              <el-form-item label="上课老师:" v-if="
                  $attrs.methodAuthTabView('学生缺课记录', '查询').viewScope !==
                    1
                ">
                <el-select size="small" @change="search" v-model="teachplan_form.tchId" placeholder="请输入老师姓名" clearable>
                  <el-option v-for="item in options3" :key="item.id" :label="item.realname + ' ' + '(' + item.name + ')'" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="search" icon="el-icon-search" v-if="$attrs.methodAuthTabView('学生缺课记录', '查询')">查询</el-button>
              </el-form-item>
              <br />
              <el-form-item label="上课时间:">
                <el-date-picker v-model="teachplan_form.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="search" placement="bottom-start">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="出勤状态:">
                <el-select size="mini" v-model="teachplan_form.state_for_search" placeholder="请选择出勤状态" clearable @change="search">
                  <el-option label="全部" value></el-option>
                  <el-option label="缺勤" value="2"></el-option>
                  <el-option label="已补课" value="1"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="newClass" v-if="$attrs.methodAuthTabView('学生缺课记录', '开班补课')">开班补课</el-button>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="exportExcel" v-if="
                    $attrs.methodAuthTabView('学生缺课记录', '导出缺课记录')
                  ">导出缺课记录</el-button>
              </el-form-item>
            </el-form>

            <!-- <el-row>
              <el-col :span="24">
                <div>
                  <el-button size="mini" type="primary">导出Excel</el-button>
                </div>
              </el-col>
            </el-row> -->

            <div class="table-style">
              <el-table size="small" id="outLTable" :data="tableData" @selection-change="handleSelectionChange1" :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }" stripe>
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->

                <el-table-column align="center" width="50" label="序号">
                  <template slot-scope="scope">
                    <span>{{
                      scope.$index + 1 + (page_no - 1) * page_size
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="campusName" label="校区名称" width="250">
                </el-table-column>

                <el-table-column prop="stuRealName" label="学员姓名" width="180">
                </el-table-column>
                <el-table-column prop="subjectName" label="科目" width="150">
                </el-table-column>

                <el-table-column prop="curriculumTitle" label="课程体系" width="150">
                </el-table-column>

                <el-table-column prop="lessonTitle" label="讲次名称" width="150">
                </el-table-column>

                <el-table-column prop="className" label="班级名称" width="250">
                </el-table-column>

                <el-table-column prop="tchPlanSignData1" label="上课时间" width="250">
                  <template slot-scope="scope">
                    <span v-if="scope.row.start_class_date">{{ scope.row.start_class_date }} -
                      {{ scope.row.end_class_date.slice(10, 19) }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="lecturerName" label="上课老师">
                </el-table-column>

                <el-table-column prop="xmGoodsName" label="消耗方式">
                </el-table-column>

                <el-table-column prop="xm_tchplan_cost_lesson_hour" label="应扣课时">
                </el-table-column>

                <el-table-column prop="" label="实扣课时" width="140">
                  <template slot-scope="scope">
                    <span v-if="scope.row.xm_cost_lesson_hour != null">{{ scope.row.xm_cost_lesson_hour }}
                      <span v-if="scope.row.xm_over_lesson_hour != 0" style="color: #f00;">(超上{{ scope.row.xm_over_lesson_hour }}课时)</span>
                    </span>
                    <span v-else> -- </span>
                  </template>
                </el-table-column>

                <!-- <el-table-column prop="stuTchPlanSignState" label="补课状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.stuTchPlanSignState === 1">
                      <span v-if="scope.row.stuTchPlanSignType === 4">已补课</span>
                    </span>
                    <span v-else>缺勤</span>
                  </template>
                </el-table-column> -->
                <el-table-column prop="stuTchPlanSignState" label="补课状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.xm_miss_state === 1">待补课</span>
                    <span v-if="scope.row.xm_miss_state === 2">补课中</span>
                    <span v-if="scope.row.xm_miss_state === 3">标记已补</span>
                    <span v-if="scope.row.xm_miss_state === 4">插班已补</span>
                  </template>
                </el-table-column>

                <el-table-column prop="lecturerName1" label="补课详情">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.xm_miss_state === 2" size="mini" @click="Detail(scope.row)">查看详情</el-button>
                    <el-button type="text" v-if="scope.row.xm_miss_state === 4" size="mini" @click="Detail(scope.row)">查看详情</el-button>
                    <el-button type="text" v-if="scope.row.xm_miss_state === 3" size="mini" @click="Detail1(scope.row)">查看详情</el-button>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="操作" fixed="right" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.xm_miss_state === 1" size="mini" @click="missedLesson(scope.row)">插班补课</el-button>
                    <el-button type="text" v-if="scope.row.xm_miss_state === 1" size="mini" @click="isMark(scope.row)">标记已补</el-button>
                    <el-button type="text" v-if="scope.row.xm_miss_state === 2" size="mini" @click="cancellation(scope.row)">取消补课</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-style">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </section>
    </div>
    <el-dialog title="签到信息" :visible.sync="dialogVisible9" width="80%" top="5vh">
      <el-row>
        <el-col :span="6">
          <div>
            <span style="font-weight: bold;">讲次名称:</span>
            <span style="margin-left: 10px">{{ lessionTitle }}</span>
          </div>
        </el-col>
        <el-col :span="18">
          <div style="overflow: hidden;">
            <div class="fl" style=" margin-right: 15px;">
              <span style="font-weight: bold;">上课日期:</span>
              <span style="margin-left: 10px">
                {{ ruleForm1.calssData }}</span>
            </div>
            <div class="fl" v-if="curriculumClassInfo1.is_cost_lesson_hour != false">
              <span style="font-weight: bold;">授课课时:</span>
              <span style="margin-left: 10px">{{ ruleForm1.cost_lesson_hour }} 课时</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-table :data="stuPlanList1" style="width: 100%;margin-top: 20px;" height="60vh" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
        <el-table-column width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no10 - 1) * page_size10 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span v-if="scope.row.stu_tch_plan_type == '1'">
              {{ scope.row.studentInfo.studentUserInfo.realname }}
            </span>
            <span v-else-if="scope.row.stu_tch_plan_type == '2'">
              {{ scope.row.studentInfo.studentUserInfo.realname }}
              <span style="color: #e6a23c">(试听)</span>
            </span>
            <span v-else-if="scope.row.stu_tch_plan_type == '3'">
              {{ scope.row.studentInfo.studentUserInfo.realname }}
              <span style="color: #e6a23c">(调课)</span>
            </span>
            <span v-else-if="scope.row.stu_tch_plan_type == '4'">
              {{ scope.row.studentInfo.studentUserInfo.realname }}
              <span style="color: #e6a23c">(补课)</span>
            </span>
            <span v-else-if="scope.row.stu_tch_plan_type == '5'">
              {{ scope.row.studentInfo.studentUserInfo.realname }}
              <span style="color: #e6a23c">(临加)</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.studentInfo.studentUserInfo.sex }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号">
          <template slot-scope="scope">
            <span>{{ scope.row.studentInfo.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="消耗方式" width="140">
          <template slot-scope="scope">
            <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
              <span>{{ scope.row.xmGoodsName }}</span>
            </span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="扣除额度" width="150">
          <template slot-scope="scope">
            <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
              <span>
                <span>{{ scope.row.cost_lesson_hour }}</span>
                <span v-if="
                    scope.row.over_lesson_hour != 0 &&
                      scope.row.over_lesson_hour != null
                  " style="color: #f00; margin-left: 10px;font-size: 12px;">(超上{{ scope.row.over_lesson_hour }}课时)</span>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="剩余课时" width="110">
          <template slot-scope="scope">
            <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
              <span v-if="
                  scope.row.stu_tch_plan_type != 4 &&
                    scope.row.stu_tch_plan_type != 5
                ">
                {{ scope.row.xm_remainTotalLessonHours }}
              </span>
              <span v-else>{{ scope.row.xm_remainTotalLessonHours }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="课消金额" show-overflow-tooltip>
          <template slot-scope="scope">
            ¥ {{ parseFloat(scope.row.cost_money).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="出勤状态">
          <template slot-scope="scope">
            <span v-if="scope.row.sign_state == 1">
              已出勤
            </span>
            <span v-else-if="scope.row.sign_state == 2">
              缺勤
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible9 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="clear1">撤销点名</el-button>
      </div> -->
      <!-- <div class="pagination-style">
        <el-pagination @size-change="handleSizeChange10" @current-change="handleCurrentChange10" :current-page="page_no10"
          :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size10"
          layout="total, sizes, prev, pager, next, jumper" :total="total10"></el-pagination>
      </div> -->
    </el-dialog>
    <el-dialog title="补课备注" :visible.sync="dialogVisible" width="30%" top="5vh">
      <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="xm_miss_content">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMark">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="班级列表" :visible.sync="dialogVisible1" width="80%" top="5vh">
      <el-form ref="form" :model="formSearch" :inline="true">
        <el-form-item label="上课时间">
          <el-date-picker size="mini" @change="changeTime" v-model="formSearch.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchTch" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- tableDataTch -->
      <el-table :data="tableDataTch" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe style="width: 100%" highlight-current-row @row-click="handleCurrent" size="mini">
        <el-table-column prop="" label="科目">
          <template slot-scope="scope">{{
            scope.row.classInfo.subjectInfo.name
          }}</template>
        </el-table-column>
        <el-table-column prop="lessionTitle" label="讲次名称"></el-table-column>
        <el-table-column label="所属班级">
          <template slot-scope="scope">{{ scope.row.classInfo.name }}</template>
        </el-table-column>
        <el-table-column prop="lecturerName" label="上课老师">
        </el-table-column>
      </el-table>
      <div class="pagination-style">
        <el-pagination @current-change="handleCurrentChangetch" :current-page="page_notch" :page-size="page_sizetch" layout="total,prev, pager, next" :total="totaltch"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="sumitStuToTeachingPlan">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="补课详情" :visible.sync="dialogVisible2" width="50%">
      <el-timeline>
        <el-timeline-item :timestamp="stuTchPlanInfo.sign_date" placement="top">
          <el-card>
            <h4>插班补课</h4>
            <p>上课班级：{{ classname }}</p>
            <p>上课时间：{{ stuTchPlanInfo.sign_date }}</p>
            <p>上课老师：{{ lecturerName }}</p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item :timestamp="stuTchPlanInfo.sign_date" placement="top">
          <el-card>
            <h4>完成补课</h4>
            <p v-if="classsign_state === 1">到课状态： 已到</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="补课详情" :visible.sync="dialogVisible3" width="50%">
      <el-timeline>
        <el-timeline-item :timestamp="start_class_date" placement="top">
          <el-card>
            <h4>标记已补</h4>
            <p>备注：{{ xm_miss_content1 }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  signMissLesson,
  getStuAbsenceRcord,
  getStuClassRecord,
  // getTchClassRecord,
  getTeachingPlanStuList,
  getTeachingPlanListForJoinClassOfMiss,
  addStuToTeachingPlanForJoinClassOfMiss,
  deleteStuFromTeachingPlanForJoinClass,
  getStuFromTeachingPlanMissInfo,
  clearTchPlan,
  getCampusUserList,
} from '@/api/educational'
import {
  api_tchPlanSelectSignRecord
} from '@/api/javaApi'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import autocomplete from '@/components/autocomplete'
import moment from 'moment'
import ExcelJS from 'exceljs'
import Bus from '@/common/bus'
import { downLoadFileExcelHandle } from '@/utils/exportExcel'

export default {
  components: {
    autocomplete,
  },
  data() {
    return {
      placementVal: 'top',
      exportData: [], // 导出的数据
      // '00:00:00', '23:59:59'
      pickerOptions1: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD' + ' 00:00:00')
              const end = moment().format('YYYY-MM-DD' + ' 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week())
                  .startOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD' + ' 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week())
                  .endOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD' + ' 23:59:59')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week() - 1)
                  .startOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD' + ' 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD' + ' 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .format('YYYY-MM-DD' + ' 00:00:00')
              const end = moment()
                .endOf('month')
                .format('YYYY-MM-DD' + ' 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD' + ' 00:00:00')
              const end = moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD' + ' 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      ruleForm1: {
        calssData: '',
        cost_lesson_hour: '',
      },
      lessionTitle: '',
      curriculumClassInfo1: {},

      dialogVisible3: false,
      start_class_date: '',
      classsign_state: null,
      classname: '',
      lecturerName: '',
      stuTchPlanInfo: {},
      dialogVisible2: false,
      formSearch: {
        time: [],
        sigin_time: [],
      },
      dialogVisible1: false,
      stuTchPlanId: '',
      dialogVisible: false,
      xm_miss_content: '',
      dialogVisible9: false,
      stuPlanList1: [],
      activeName: 'second',
      //缺勤记录查询
      teachplan_form1: {
        start_date: '',
        end_date: '',
        time: [],
      },
      teachplan_form: {
        time: [],
      },
      //课程包列表
      curriculumList: [],
      //补课状态
      makeUpLessonsList: [],
      //退课状态
      dopOutList: [],
      //缺课记录列表
      tableData: [],
      //分页管理
      page_no: 1,
      page_size: 20,
      total: 0,
      //老师上课记录
      form: {
        className: '',
        isCostLessonHour: '0',
        time: [],
      },
      form1: {
        start_date: '',
        end_date: '',
      },

      //老师上课记录列表
      tableData1: [],
      //分页管理
      page_no1: 1,
      page_size1: 20,
      total1: 0,
      //学生上课记录查询
      stuForm: {},
      stuForm1: {
        time: [],
      },
      //上课状态
      classStatusList: [],
      //   学生上课列表
      tableData2: [],
      teachingPlanId: '',
      //分页管理
      page_no2: 1,
      page_size2: 20,
      total2: 0,
      page_no10: 1,
      page_size10: 20,
      total10: 0,
      lessonId: '',
      xmGoodsId: '',
      page_notch: 1,
      page_sizetch: 10,
      totaltch: 1,
      tableDataTch: [],
      teaching_plan_id: '',
      stuTchPlanIdToTch: '',
      campusIds: '',
      stuTchPlanIdMissInfo: '',
      xm_miss_content1: '',
      stuId: '',
      options3: [],
    }
  },
  async mounted() {
    await this.getCampusUserList1()
    if (this.$route.query.active != undefined) {
      this.activeName = this.$route.query.active
      this.getStuAbsenceRcord()
    }
    //this.getStuAbsenceRcord();
    this.getTchClassRecord()
    Bus.$on('updateRecord', () => {
      this.search2()
    })
  },
  methods: {
    async getCampusUserList1() {
      return getCampusUserList({
        // campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res, 12356)
        this.options3 = res.campusUserList
        // if (this.$attrs.methodAuthTabView('点名记录', '查询').viewScope === 1) {
        //   this.form.tchId = this.$store.state.user.userInfo.id
        // }
        if (
          this.$attrs.methodAuthTabView('学生缺课记录', '查询').viewScope === 1
        ) {
          this.teachplan_form.tchId = this.$store.state.user.userInfo.id
        }
      })
    },
    getUserId(row) {
      console.log(row, 123456)
      this.stuId = row
    },
    getUserName(row) {
      console.log(row, 123456)
    },
    //撤销点名记录
    clear1() {
      console.log(123)
      this.$confirm('确定要清空本节课的上课记录和出勤记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        clearTchPlan({
          teaching_plan_id: this.teachingPlanId,
        }).then((res) => {
          this.$message.success('清空记录成功')
          console.log(res)
          this.search2()
        })
      })
    },
    Detail1(row) {
      console.log(row, 789465)
      this.xm_miss_content1 = row.xm_miss_content
      this.start_class_date = row.start_class_date
      this.dialogVisible3 = true
    },
    Detail(row) {
      console.log(row, 7894566)
      this.stuTchPlanIdMissInfo = row.stuTchPlanId
      this.getStuFromTeachingPlanMissInfo()
      this.dialogVisible2 = true
    },
    getStuFromTeachingPlanMissInfo() {
      getStuFromTeachingPlanMissInfo({
        stuTchPlanId: this.stuTchPlanIdMissInfo,
      }).then((res) => {
        console.log(res, 7894586)
        this.stuTchPlanInfo = res.stuTchPlanInfo
        this.classname = this.stuTchPlanInfo.techPlanInfo.classInfo.name
        this.classsign_state = this.stuTchPlanInfo.techPlanInfo.sign_state
        this.lecturerName = this.stuTchPlanInfo.techPlanInfo.lecturerName
      })
    },
    cancellation(row) {
      this.$confirm('是否取消补课?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteStuFromTeachingPlanForJoinClass({
            stuTchPlanId: row.stuTchPlanId,
          }).then(() => {
            this.$message.success('取消补课成功')
            this.getStuAbsenceRcord()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    changeTime(val) {
      this.formSearch.time = val
    },
    searchTch() {
      this.page_notch = 1
      this.getTeachingPlanListForJoinClassOfMiss()
    },
    handleCurrent(val) {
      this.teaching_plan_id = val.id
    },
    sumitStuToTeachingPlan() {
      addStuToTeachingPlanForJoinClassOfMiss({
        teaching_plan_id: this.teaching_plan_id,
        stuTchPlanId: this.stuTchPlanIdToTch,
      }).then(() => {
        this.$message.success('添加成功!')
        this.dialogVisible1 = false
        this.getStuAbsenceRcord()
      })
    },
    handleCurrentChangetch(val) {
      this.page_notch = val
      this.getTeachingPlanListForJoinClassOfMiss()
    },
    missedLesson(row) {
      this.stuTchPlanIdToTch = row.stuTchPlanId
      if (row.xmGoodsId === null) {
        this.xmGoodsId = ''
      } else {
        this.xmGoodsId = row.xmGoodsId
      }
      this.lessonId = row.lessonId
      this.campusIds = row.campusId
      this.getTeachingPlanListForJoinClassOfMiss()
      this.dialogVisible1 = true
      // this.dialogVisible1 = true
    },
    getTeachingPlanListForJoinClassOfMiss() {
      getTeachingPlanListForJoinClassOfMiss({
        start_date: this.formSearch.time == null ? '' : this.formSearch.time[0],
        end_date: this.formSearch.time == null ? '' : this.formSearch.time[1],
        lessionId: this.lessonId,
        xm_goods_id: this.xmGoodsId,
        campusIds: JSON.stringify([this.campusIds]),
        page_no: this.page_notch,
        page_size: this.page_sizetch,
      }).then((res) => {
        this.tableDataTch = res.teachingPlan
        this.totaltch = res.total
      })
    },
    newClass() {
      if (
        this.$store.state.user.selected_schools.length == 0 ||
        this.$store.state.user.selected_schools.length > 1
      ) {
        this.$message.warning('请选择1个目标校区')
      } else {
        this.$router.push({
          name: 'newClass',
          query: {
            active: 'first',
          },
        })
      }
    },
    isMark(row) {
      this.stuTchPlanId = row.stuTchPlanId
      this.dialogVisible = true
    },
    submitMark() {
      signMissLesson({
        stuTchPlanId: this.stuTchPlanId,
        xm_miss_content: this.xm_miss_content,
      }).then(() => {
        this.dialogVisible = false
        this.$message.success('标记补课成功')
        this.getStuAbsenceRcord()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    handleExportmsg() {
      // 创建一个工作簿
      var workbook = new ExcelJS.Workbook()

      // 创建一个工作表
      var worksheet = workbook.addWorksheet('Sheet1')

      // 将数据添加到工作表中
      worksheet.addRow([
        '序号',
        '姓名',
        '性别',
        '账号',
        '消耗方式',
        '扣除额度',
        '剩余课时',
        '课消金额',
        '出勤状态',
      ])
      this.stuPlanList1.forEach((item, index) => {
        worksheet.addRow([
          index + 1,
          item.tchPlanSignData,
          item.className,
          item.lessonTitle,
          item.start_class_date + ' -' + item.end_class_date.slice(10, 19),
          item.lecturerName,
          item.costLessonHour,
          item.stuSignNum,
          item.stuTotalNum,
        ])
      })
      worksheet.columns.forEach((column, index) => {
        if (index === 11) {
          column.eachCell({ includeEmpty: true }, function (cell) {
            cell.numFmt = '0.00' // 设置数据格式为数字，保留两位小数
          })
        }
        let maxLength = 0
        column.eachCell({ includeEmpty: true }, (cell) => {
          const textLength = cell.value ? cell.value.toString().length : 0
          if (textLength > maxLength) {
            maxLength = textLength
          }
        })
        column.width = Math.min(50, Math.max(10, maxLength * 1.2))
      })
      // 自定义样式
      let headerRow = worksheet.getRow(1)
      headerRow.eachCell((cell) => {
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF1878FF' }, // 设置颜色代码，
        }
      })
      // worksheet.getRow(1).font = { bold: true };
      worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
        console.log(rowNumber)
        row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
          cell.alignment = { horizontal: 'center' }
          console.log(colNumber)
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }
        })
      })

      // 生成Excel文件
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        FileSaver.saveAs(data, '老师上课记录.xlsx')
      })
    },

    handleExport() {
      const params = {
        userId: this.form.tchId,
        currTitle: this.form.lesson_title,
        className: this.form.className,
        costLessonHourState: this.form.isCostLessonHour,
        startClassDate: this.form.time ? this.form.time[0] : '',
        endClassDate: this.form.time ? this.form.time[1] : '',
        startSignDate: this.form.sigin_time ? this.form.sigin_time[0] : '',
        endSignDate: this.form.sigin_time ? this.form.sigin_time[1] : '',
        eduCampusId: this.$store.state.user.selected_schools[0],
      }
      downLoadFileExcelHandle('/java-api/school/tchPlan/exportSignRecord', params, '点名记录')

    },

    // exportExcel1() {
    //   var xlsxParam = { raw: true };
    //   /* 从表生成工作簿对象 */
    //   var wb = XLSX.utils.table_to_book(
    //     document.querySelector("#outLTable1"),
    //     xlsxParam
    //   );
    //   /* 获取二进制字符串作为输出 */
    //   var wbout = XLSX.write(wb, {
    //     bookType: "xlsx",
    //     bookSST: true,
    //     type: "array",
    //   });
    //   try {
    //     FileSaver.saveAs(
    //       //Blob 对象表示一个不可变、原始数据的类文件对象。
    //       //Blob 表示的不一定是JavaScript原生格式的数据。
    //       //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
    //       //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
    //       new Blob([wbout], { type: "application/octet-stream" }),
    //       //设置导出文件名称
    //       "老师上课记录.xlsx"
    //     );
    //   } catch (e) {
    //     if (typeof console !== "undefined") console.log(e, wbout);
    //   }
    //   return wbout;
    // },
    exportExcel() {
      /* 从表生成工作簿对象 */
      //var wb = XLSX.utils.table_to_book(document.querySelector("#outLTable"));
      let tableDom = document.querySelector('#outLTable').cloneNode(true)
      let tableHeader = tableDom.querySelector('.el-table__header-wrapper')
      let tableBody = tableDom.querySelector('.el-table__body')
      tableHeader.childNodes[0].append(tableBody.childNodes[1])
      let headerDom = tableHeader.childNodes[0].querySelectorAll('th')
      // 移除左侧checkbox的节点
      if (headerDom[0].querySelectorAll('.el-checkbox').length > 0) {
        headerDom[0].remove()
      }
      for (let key in headerDom) {
        if (headerDom[key].innerText === '操作') {
          headerDom[key].remove()
        }
      }
      // 清理掉checkbox 和操作的button
      let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll(
        'td'
      )
      for (let key = 0; key < tableList.length; key++) {
        if (
          tableList[key].querySelectorAll('.el-checkbox').length > 0 ||
          tableList[key].querySelectorAll('.el-button').length > 0
        ) {
          tableList[key].remove()
        }
      }
      // 获取web的节点
      let webBook = XLSX.utils.table_to_book(tableHeader)
      // 把当前的book节点写入XLSX中
      let webOut = XLSX.write(webBook, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        FileSaver.saveAs(
          new Blob([webOut], { type: 'application/octet-stream' }),
          '学生缺课记录' + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, webOut)
      }
    },
    handleSizeChange10(val) {
      console.log(123)
      this.page_size10 = val
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        res.stuPlanList.map((item) => {
          if (item.cost_money == null) {
            item.cost_money = 0
          }
        })
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
    },
    handleCurrentChange10(val) {
      this.page_no10 = val
      console.log(123)
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        res.stuPlanList.map((item) => {
          if (item.cost_money == null) {
            item.cost_money = 0
          }
        })
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
    },
    num(row) {
      this.lessionTitle = row.lessonTitle
      this.ruleForm1.calssData = row.start_class_date
      this.teachingPlanId = row.id

      this.dialogVisible9 = true
      console.log(row, 4564)
      getTeachingPlanStuList({
        teachingPlanId: row.tchPlanId,
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        this.curriculumClassInfo1 = res.curriculumClassInfo
        console.log(res, 'stuPlanList1')
        res.stuPlanList.map((item) => {
          if (item.cost_money == null) {
            item.cost_money = 0
          }
        })
        this.stuPlanList1 = res.stuPlanList
        if (this.curriculumClassInfo1.is_cost_lesson_hour != false) {
          this.ruleForm1.cost_lesson_hour = this.curriculumClassInfo1.lesson_hour
        }

        // this.ruleForm1.calssData = row.class_date
        // this.ruleForm1.startTime = row.start_class_date.substr(row.start_class_date.length - 8)
        // this.ruleForm1.endTime = row.end_class_date.substr(row.end_class_date.length - 8)

        // this.total10 = res.total;
      })
    },
    handleClick(val) {
      console.log('切换菜单')
      console.log(val.index)

      if (val.index === '0') {
        this.page_no1 = 1
        this.getTchClassRecord()
      }
      if (val.index === '1') {
        this.page_no = 1
        this.getStuAbsenceRcord()
      }
    },
    //选择退课学员
    handleSelectionChange1(val) {
      console.log(val)
    },
    search() {
      this.page_no = 1
      this.getStuAbsenceRcord()
    },
    //缺课记录

    getStuAbsenceRcord() {
      getStuAbsenceRcord({
        sign_state: this.teachplan_form.state_for_search,
        // stu_realname: this.teachplan_form.stu_realname,
        stuId: this.stuId,
        lesson_title: this.teachplan_form.lesson_title,
        tchId: this.teachplan_form.tchId,
        start_date: this.teachplan_form.time ? this.teachplan_form.time[0] : '',
        end_date: this.teachplan_form.time ? this.teachplan_form.time[1] : '',
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.tableData = res.returnDataArr
        this.total = res.total
      })
    },

    //缺勤分页
    handleSizeChange(val) {
      this.page_size = val
      this.getStuAbsenceRcord()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getStuAbsenceRcord()
    },
    //选择老师上课记录列表
    handleSelectionChange2(val) {
      console.log(val)
    },
    search2() {
      this.page_no1 = 1
      this.getTchClassRecord()
    },
    getTchClassRecord() {
      api_tchPlanSelectSignRecord({
        userId: this.form.tchId,
        currTitle: this.form.lesson_title,
        className: this.form.className,
        costLessonHourState: this.form.isCostLessonHour,
        startClassDate: this.form.time ? this.form.time[0] : '',
        endClassDate: this.form.time ? this.form.time[1] : '',
        startSignDate: this.form.sigin_time ? this.form.sigin_time[0] : '',
        endSignDate: this.form.sigin_time ? this.form.sigin_time[1] : '',
        eduCampusId: this.$store.state.user.selected_schools[0],
        pageRequest: {
          pageNum: this.page_no1,
          pageSize: this.page_size1,
        },
      }).then((res) => {
        console.log(res)
        // res.totalCostMoney
        res.content.map((item) => {
          // item.campusName= item."五格殿下-演示校区"
          // item.curriculumTitle= item."牙齿大街的故事"
          // item.end_class_date= item."2024-11-26 21:00:00"
          // item.subjectName= item."Jrcode"
          // item.totalCostLessonHour= item.0
          // item.totalOverLessonHour= item.
          // item.className = item.className
          // item.costLessonHour = item.costLessonHour
          item.lecturerName = item.tchName
          item.lessonTitle = item.currTitle
          item.start_class_date = item.startClassStr
          // item.stuSignNum = item.attendRate
          // item.stuTotalNum = item.attendRate
          // item.tchPlanId = item.tchPlanId
          item.tchPlanSignData = item.signDate
          item.totalCostMoney = item.costAmount
          // if (item.totalCostMoney == null) {
          //   item.totalCostMoney = 0
          // }
        })
        this.tableData1 = res.content
        this.total1 = res.totalSize
      })
    },
    //老师上课分页
    handleSizeChange1(val) {
      this.page_size1 = val
      this.getTchClassRecord()
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getTchClassRecord()
    },

    search3() {
      this.page_no2 = 1
      this.getStuClassRecord()
    },
    //获取学生上课记录列表
    getStuClassRecord() {
      getStuClassRecord({
        ...this.stuForm,
        start_date: this.stuForm1.time ? this.stuForm1.time[0] : '',
        end_date: this.stuForm1.time ? this.stuForm1.time[1] : '',
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log(res)
        this.tableData2 = res.returnDataArr
        this.total2 = res.total
      })
    },
    //选择学生上课记录
    handleSelectionChange3(val) {
      console.log(val)
    },
    //老师上课分页
    handleSizeChange2(val) {
      this.page_size2 = val
      this.getStuClassRecord()
    },
    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getStuClassRecord()
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-divider--horizontal {
  margin: 0;
  margin-bottom: 20px;
}

.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.classRecord {
  min-height: calc(100% - 30px);
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
    padding-left: 10px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.table-style {
}

.stu {
  width: 100%;
  height: 40px;
  background: rgba(51, 126, 245, 0.5);
  border: 2px solid rgb(51, 126, 245);
  border-radius: 5px;
  margin-top: 20px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 10px;
}

.stu span {
  margin-right: 10px;
}

/deep/ .el-icon-info:before {
  color: rgb(51, 126, 245);
  margin-right: 10px;
}

.fl {
  float: left;
}
</style>
